export const ErrorEnLocale = {
  'error.title': 'Error',
  'error.description': 'An error occurred while trying to load the page.',
  'error.reload': 'Try again',
  'error.take-me-home': 'Take me home',

  'error.noResults': 'No results found',
} as const;

export const ErrorEsLocale = {
  'error.title': 'Error',
  'error.description': 'Ocurrió un error al intentar cargar la página.',
  'error.reload': 'Intentar de nuevo',
  'error.take-me-home': 'Ir al inicio',

  'error.noResults': 'No se encontraron resultados',
} as const;
